import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import _ from 'lodash';
import { SharedModule } from '../../../../shared/shared.module';
import { Product, UpdateInventory, gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { InventoryService } from '../../../../services/inventory.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { billofmaterial, billofmaterialGridResponse, ManufacturingOrders } from '../../../../model/inventory.model';
import { UnitsOfMeasure, Warehouse, Vendor } from '../../../../model/administration.model';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { ProjectBomLookupComponent } from '../../../Lookup/projectbom-lookup/projectbom-lookup.component';
import { SalesService } from '../../../../services/sales.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { VendorService } from '../../../../services/vendor.service';
import { StoreConsumptionLookupComponent } from '../../../Lookup/store-consumption-lookup/store-consumption-lookup.component';
import { setCurrentTimeOnDates } from '../../../../services/utils/date-utils';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-create-mo',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  providers: [DialogService, MessageService],
  templateUrl: './create-manufacturingorders.component.html',
  styleUrl: './create-manufacturingorders.component.scss'
})
export class CreateMOComponent implements OnInit {
  manufacturingBatchID: any;
  projectManufacturingBatchID: any;
  manufacturingBOMID: any;
  loader: boolean = false;
  isEditMode: any;
  submitted: boolean = false;
  displayMaximizable: boolean | undefined;
  ProductBoMId: any
  tableData: any;
  refData: { ProductBoMId: any; } | undefined;
  displayBasic: boolean = false;
  projectBoMId: any;
  projectBoMIds: any;
  statusF: any;
  ManufacturingBatchID: any;
  manufacturingBOMLineItemID: any;
  ProductBomId: any;
  productBoMId: any;
  productId: any;
  warehouseDropdown: any[] = [];
  UOMDropdown: UnitsOfMeasure[] = [];
  filteruom: UnitsOfMeasure[] = [];
  filtewarehouse: Warehouse[] = [];
  vendorDropdown: any[] = [];
  filterVendorList: any[] = [];
  menuOptions: any[] = [];
  lineItemData: any[] = [];
  NewLineItemData: any[] = [];
  data: any;
  billlineItemData: any[] = [];
  billlineItemDataforstatuschange: any[] = [];
  billOfMaterialLineitems: any[] = [];
  savedData: any;
  isEdit: boolean = false;
  deleteProductIds: any[] = [];
  manufacturingOrders: ManufacturingOrders[] = [];
  selectedbillofmaterial: billofmaterial[] = [];
  products: Product[] = [];
  isInProcessChecked: boolean = false;
  status: any;
  selectedProduct: any[] = [];
  filterFinishGoodList: any[] = [];
  warehouseId: any;
  QOHFromInventry: any[] = [];
  productCode: any;
  SaveData: any;
  SaveDataLineItem: any[] = [];
  storeconsumptionLineItemData: any[] = [];
  refStoreConsumption: DynamicDialogRef | undefined;
  isBatchNumberReadOnly: boolean = false;
  originalQuantity: any;
  productIds: any;
  batchQuantity: any;
  warehouseCode: any;
  challanList: any[] = [];
  selectedChallan: any[] = [];
  projectData: any;
  today: Date = new Date();
  QAvail: number = 0;
  QProcess: number = 0;
  editedItems: any[] = [];
  finishClicked = false;
  unitLabel: string = '';
  private autoPOStatus = 'Pending Level 1 Approval';


  constructor(private inventoryService: InventoryService, private messageService: MessageService, public dialogService: DialogService, public ref: DynamicDialogRef, private purchaseorderService: PurchaseorderService, private billofmaterialservice: InventoryService, private route: Router, private router: ActivatedRoute,
    private salesService: SalesService, private administratorService: AdministratorService, private vendorService: VendorService, private confirmationService: ConfirmationService
  ) { }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10,
    id: 0
  }

  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 10
  }


  manufacturingOrdersForm = new FormGroup({
    projectManufacturingBatchID: new FormControl(0),
    batchNumber: new FormControl('', Validators.required),
    fgQuantity: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    quantityOnHand: new FormControl(),
    manufacturingBOMID: new FormControl(0),
    projectBoMId: new FormControl(),
    fgProductCode: new FormControl('', Validators.required),
    projectName: new FormControl(),
    projectBOMCode: new FormControl(''),
    productId: new FormControl(),
    ProjectBoMName: new FormControl(''),
    Comment: new FormControl(),
    IsActive: new FormControl(true),
    CreatedBy: new FormControl(),
    quantity: new FormControl(0, [Validators.required, Validators.min(1)]),
    createdDate: new FormControl(),
    startDate: new FormControl<Date | null>(null, Validators.required),
    endDate: new FormControl<Date | null>(null, Validators.required),
    status: new FormControl(''),
    inProcess: new FormControl(false),
    warehouse: new FormControl(),
    warehouseId: new FormControl(),
    warehouseCode: new FormControl('', Validators.required),
    unitsOfMeasureId: new FormControl(),
    unitsOfMeasureCode: new FormControl('', Validators.required),
    UnitOfMeasure: new FormControl(),
    boMType: new FormControl('', Validators.required),
    // wasteQuantity: new FormControl(0),
    lotNumber: new FormControl('')

  })

  manufacturingOrdersFormLineItems = new FormGroup({
    CreatedBy: new FormControl(),

  })

  result: billofmaterialGridResponse = {
    billOfMaterials: [],
    totalRecords: 0
  }

  ngOnInit(): void {
    const username = localStorage.getItem('username');
    this.manufacturingOrdersForm.controls.CreatedBy.setValue(username);
    this.manufacturingOrdersFormLineItems.controls.CreatedBy.setValue(username);
    document.title = 'Create Manufacturing Order';
    this.getUOM();
    this.patchManufacturingOrders();
    this.getWarehouse();
    this.getChallan();
    this.getVendors();
    if (!this.isEditMode) {
      this.manualEntry();
    }

    this.manufacturingOrdersForm.get('fgQuantity')?.valueChanges.subscribe(batchQuantity => {
      this.updateWasteQuantity();
    });

    this.manufacturingOrdersForm.get('quantity')?.valueChanges.subscribe(finishQuantity => {
      this.updateWasteQuantity();
    });

    this.router.queryParams.subscribe(params => {
      const projectBoMIds = params['projectBoMIds']?.split(',').map(Number) || [];
      const productBoMIds = params['productBoMIds']?.split(',').map(Number) || [];
      const statuses = params['statuses']?.split(',') || [];

      if (projectBoMIds.length && productBoMIds.length && statuses.length) {
        this.projectBoMId = projectBoMIds;
        this.productBoMId = productBoMIds;
        this.statusF = statuses;

        this.selectedProduct = [];
        for (let i = 0; i < projectBoMIds.length; i++) {
          this.selectedProduct.push({
            projectBoMId: projectBoMIds[i],
            productBoMId: productBoMIds[i],
            status: statuses[i]
          });
        }

        this.selectedProduct.forEach(product => {
          if (product.projectBoMId) {
            this.manufacturingOrdersForm.controls.projectBoMId.setValue(product.projectBoMId);
            this.getLineItemBOMForMO(product.projectBoMId);
          }
        });
      } else {

      }
    });
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
    });
  }


  updateWasteQuantity() {
    const batchQuantity = Number(this.manufacturingOrdersForm.controls.fgQuantity.value) || 0;
    const finishQuantity = Number(this.manufacturingOrdersForm.controls.quantity.value) || 0;

    if (batchQuantity && finishQuantity) {
      const wasteQuantity = batchQuantity - finishQuantity;
      // this.manufacturingOrdersForm.controls.wasteQuantity.setValue(wasteQuantity);
    } else {
      // this.manufacturingOrdersForm.controls.wasteQuantity.setValue(0);
    }
  }

  loadBom(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    //this.getBillOfMaterial(this.pageRequest);
  }

  updateProjectBOM(data?: any) {
    if (data) {
      this.route.navigate(['/home/createproject'], { queryParams: { 'projectBoMId': data }, skipLocationChange: true },);
    } else {
      this.route.navigate(['/home/createproject'], { queryParams: { 'projectBoMId': this.selectedbillofmaterial[0].productBoMId }, skipLocationChange: true },);
    }
  }

  getProduct() {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '65%',
      data: { Material: 'FG1112' }
    });

    this.ref.onClose.subscribe((data: any) => {
      if (!data) return;

      this.manufacturingOrdersForm.patchValue({
        projectBoMId: data.projectBoMId,
        projectBOMCode: data.projectBoMCode + ' - ' + data.projectBoMName,
        projectName: data.projectBoMName,
      });

      // this.projectData = data;
      // this.projectBoMId = data.projectBoMId;
      // this.projectBoMIds = data.projectBoMId;
      // this.billlineItemDataforstatuschange = data.billOfMaterials;

      // only a NEW job resets the finished good, quantity, unit and UOM.
      // A saved job keeps them and only the project changes.
      // if (!this.isEditMode) {
      //   this.NewLineItemData = [];
      //   this.manufacturingOrdersForm.controls.fgProductCode.reset();
      //   this.manufacturingOrdersForm.controls.fgQuantity.reset();
      //   this.manufacturingOrdersForm.controls.unitsOfMeasureId.reset();
      //   this.manufacturingOrdersForm.controls.unitsOfMeasureCode.reset();
      //   this.manufacturingOrdersForm.controls.warehouse.reset();
      //   this.manufacturingOrdersForm.controls.warehouseId.reset();
      //   this.manufacturingOrdersForm.controls.quantityOnHand.reset();
      // }
    });
  }

  getLineItemBOMForMO(data: any) {
    this.billofmaterialservice.getProjectBillOfMaterialLineItem(data).subscribe({
      next: (response: any) => {
        if (response && response.length > 0) {
          const newLineItems: any[] = [];

          this.selectedProduct.forEach((product) => {
            const filteredLineItems = response.filter((item: any) =>
              item.productBoMId === Number(product.productBoMId) &&
              item.projectBoMId === Number(product.projectBoMId)
            );

            if (filteredLineItems.length > 0) {
              filteredLineItems.forEach((item: any) => {
                const exists = newLineItems.some(existingItem => existingItem.productBoMId === item.productBoMId && existingItem.projectBoMId === item.projectBoMId);
                if (!exists) {
                  newLineItems.push(item);
                }
              });

              this.getBillOfMaterialLineItem(filteredLineItems[0].productBoMId);
              this.data = filteredLineItems[0];

              this.getManufacturingBatch();

              this.inventoryService.getProjectBomId(product.projectBoMId).subscribe({
                next: (data: any) => {
                  this.projectData = data;
                  if (data) {
                    const createdDate = data.createdDate ? new Date(data.createdDate) : null;
                    this.manufacturingOrdersForm.patchValue({
                      projectBoMId: data.projectBoMId,
                      projectBOMCode: data.projectBoMCode,
                      projectName: data.projectBoMName,
                      productId: filteredLineItems[0].productId,
                      startDate: createdDate,
                      warehouseId: filteredLineItems[0].warehouseId,
                      warehouseCode: filteredLineItems[0].warehouseCode,
                      unitsOfMeasureId: filteredLineItems[0].unitsOfMeasureId,
                      unitsOfMeasureCode: filteredLineItems[0].unitsOfMeasureCode,
                      fgQuantity: filteredLineItems[0].quantity,
                      fgProductCode: filteredLineItems[0].productCode,
                      boMType: filteredLineItems[0].boMType,
                      quantityOnHand: filteredLineItems[0].quantityOnHand,
                      manualEntry: true

                    });
                  }

                  this.isBatchNumberReadOnly = true;
                },
                error: (error: any) => {
                  console.error("Error fetching BOM ID:", error);
                }
              });
            } else {
              console.log(`No matching line items found for productBoMId: ${product.productBoMId}`);
            }
          });

          this.lineItemData = [...newLineItems];
        }
      },
      error: (error: any) => {
        console.error("Error fetching data:", error);
      }
    });
  }


  saveMO(data: any, isEditMode: boolean) {
    this.submitted = true;

    this.manufacturingOrdersForm.get('endDate')?.clearValidators();
    this.manufacturingOrdersForm.get('quantity')?.clearValidators();
    this.manufacturingOrdersForm.get('endDate')?.updateValueAndValidity();
    this.manufacturingOrdersForm.get('quantity')?.updateValueAndValidity();

    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    // if (this.lineItemData.length < 1) {

    //   this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
    //   return;
    // }

    if (data.endDate) {
      this.messageService.add({
        severity: 'error',
        detail: 'Finish Date is restricted for this operation.'
      });

      if (data.endDate) {
        this.manufacturingOrdersForm.controls.endDate.reset();
      }

      return;

    }

    data.status = this.manufacturingOrdersForm.controls.status.value;
    if (isEditMode) {
      this.updateMO(data);
    } else {
      this.createMO(data);
    }
  }

  async createMO(data: any): Promise<void> {
    this.submitted = true;
    const isValid = this.validateForm();

    if (!isValid) { return; }
    if (!data.inProcess) {
      const startDate = data.startDate as Date;
      const endDate = data.endDate as Date;
      if (startDate && endDate && endDate < startDate) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Date Range',
          detail: 'The finish date cannot be before the start date.'
        });
        return;
      }

      if (data.status === 'Batch Finished') {
        data.status = 'Batch Finished';
      } else {
        data.status = 'Batch Created';
      }

    }

    this.loader = true;
    const currentTime = new Date();
    data.startDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());

    // Create a clean data object matching backend model exactly
    const manufacturingBatchData = {
      projectManufacturingBatchID: 0,
      projectBoMId: data.projectBoMId || null,
      projectName: data.projectName || null,
      batchNumber: data.batchNumber,
      fgProductCode: data.fgProductCode?.split(' - ')[0] || data.fgProductCode,
      fgQuantity: Number(data.fgQuantity) || 0,
      warehouseId: data.warehouseId || null,
      warehouseCode: data.warehouseCode || null,
      quantityOnHand: data.quantityOnHand || null,
      boMType: data.boMType || null,
      unitsOfMeasureId: data.unitsOfMeasureId || null,
      unitsOfMeasureCode: data.unitsOfMeasureCode || null,
      wasteQuantity: Number(data.wasteQuantity) || 0,
      lotNumber: data.lotNumber || null,
      projectBOMCode: data.projectBOMCode ? data.projectBOMCode.split(' - ')[0] : null,
      productId: data.productId || null,
      projectBoMName: data.fgProductCode?.split(' - ')[0] || data.fgProductCode || '',
      status: data.status || 'Batch Created',
      quantity: Number(data.quantity) || 0,
      startDate: data.startDate,
      endDate: data.endDate || null,
      totReqWeight: Number(data.totReqWeight) || 0,
      totReqQuantity: Number(data.totReqQuantity) || 0,
      comment: data.Comment || null,
      isActive: true,
      createdBy: data.CreatedBy || localStorage.getItem('username'),
      createdDate: new Date()
    };

    // Ensure required fields are not null
    if (!manufacturingBatchData.unitsOfMeasureId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Unit of Measure is required.'
      });
      this.loader = false;
      return;
    }

    if (!manufacturingBatchData.warehouseId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Warehouse is required.'
      });
      this.loader = false;
      return;
    }

    try {
      const response = await this.purchaseorderService.createProjectManufacturingOrders(manufacturingBatchData).toPromise();
      this.projectManufacturingBatchID = response.id;

      // Only update project if we have project data
      if (this.projectData && this.projectData.projectBoMId) {
        const updatedProjectData = { ...this.projectData };
        updatedProjectData.status = 'In Process';
        delete updatedProjectData.billOfMaterials;
        await this.inventoryService.updateProject(updatedProjectData).toPromise();
      }

      await this.getManufacturingBOMData('');

      if (this.SaveData) {
        this.SaveData.projectManufacturingBatchID = this.projectManufacturingBatchID;
      }

      if (this.storeconsumptionLineItemData.length > 0) {
        this.storeconsumptionLineItemData.forEach(item => {
          item.projectManufacturingBatchID = this.projectManufacturingBatchID;
        });
        await this.updateStoreConumption(this.storeconsumptionLineItemData);
      }
      this.loader = false;

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Manufacturing Batch Created Successfully.'
      });

      setTimeout(() => {
        this.route.navigate(['/home/listManufacturingOrders']);
      }, 1000);
    } catch (error) {
      this.loader = false;
      console.error('Error creating MO:', error);
      const errorMessage = error instanceof Error
        ? error.message
        : typeof error === 'object' && error !== null && 'error' in error &&
          typeof error.error === 'object' && error.error !== null && 'message' in error.error
          ? String(error.error.message)
          : 'Unknown error';
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'An error occurred while creating Manufacturing Batch: ' + errorMessage
      });
    }

  }

  async getManufacturingBOMData(savedDataString: any): Promise<void> {
    this.lineItemData.push(savedDataString);
    if (!Array.isArray(this.NewLineItemData) || this.NewLineItemData.length === 0) return;

    const lineItems = this.NewLineItemData.flat().map(item => {
      const { product, ...rest } = item;
      return {
        ...rest,
        isActive: item.isActive ?? true,
        manufacturingBOMLineItemID: 0,
        manufacturingBOMID: 0,
        warehouseId: this.manufacturingOrdersForm.controls.warehouseId.value,
        createdBy: localStorage.getItem('username'),
      };
    });

    const formVal = this.manufacturingOrdersForm.value;
    const manufacturingBOMRecord = {
      manufacturingBOMID: 0,
      projectManufacturingBatchID: this.projectManufacturingBatchID,
      projectBoMId: this.projectBoMId || null,
      productId: formVal.productId,
      productCode: formVal.fgProductCode?.split(' - ')[0],
      warehouseId: formVal.warehouseId,
      warehouseCode: formVal.warehouseCode,
      unitsOfMeasureId: formVal.unitsOfMeasureId,
      unitsOfMeasureCode: formVal.unitsOfMeasureCode,
      boMType: formVal.boMType,
      quantity: Number(formVal.fgQuantity) || 0,
      createdBy: localStorage.getItem('username'),
      isActive: true,
      manufacturingBOMLineItems: lineItems,
    };

    await this.purchaseorderService.createManufacturingBOM([manufacturingBOMRecord]).toPromise();
    await this.updatePOInventory(lineItems);
  }


  getBillOfMaterialLineItem(data: any) {
    this.inventoryService.getBomLineItem(data).subscribe({
      next: (response: any) => {
        const items: any[] = Array.isArray(response) ? response : [response];

        items.forEach(item => {
          item.totQty = (Number(item.compQuantity) || 0) + (Number(item.wastage) || 0);
          item.productCost = this.getProductCost(item);
          item.extendedCost = this.getExtendedCost(item);
        });

        this.NewLineItemData = [...this.NewLineItemData, ...items];

        // refresh Q-Avail / Q-Process for the new rows
        if (this.warehouseId) {
          this.getInventoryStatusByWarehouse();
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getProductCost(item: any): number {
    return Number(item?.productCost ?? item?.standardCost ?? item?.product?.standardCost ?? 0);
  }

  getLineItemMO(data: any) {
    this.loader = true;
    this.purchaseorderService.getManufacturingBOMById(data).subscribe(
      (data: any) => {
        for (let item of data) {
          if (item.manufacturingBOMLineItems && Array.isArray(item.manufacturingBOMLineItems)) {
            for (let lineItem of item.manufacturingBOMLineItems) {
              if (lineItem.wipDate) {
                lineItem.wipDate = new Date(lineItem.wipDate);
              }
            }
            this.NewLineItemData.push(...item.manufacturingBOMLineItems);
          }
        }

        this.getInventoryStatusByWarehouse();
        // this.NewLineItemData = data;
        this.lineItemData = this.loadProducts(data);
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  loadProducts(data: any): any[] {
    //console.log(data);
    return data.map((item: any) => {
      return this.loadProduct(item);
    });
  }

  loadProduct(data: any) {
    const manufacturingOrders: any = {
      productCode: data.productCode,
      projectManufacturingBatchID: data.projectManufacturingBatchID,
      manufacturingBOMID: data.manufacturingBOMID,
      productId: data.productId,
      productBoMId: data.productBoMId,
      projectBoMId: this.projectBoMId,
      productName: data.product.productName,
      quantity: data.quantity,
      warehouseCode: data.warehouseCode,
      warehouseId: data.warehouseId,
      unitsOfMeasureId: data.unitsOfMeasureId,
      boMType: data.boMType,
      createdBy: data.createdBy,
      unitsOfMeasureCode: data.unitsOfMeasureCode,
      createdDate: data.createdDate

    }
    return manufacturingOrders;
  }


  updateMO(data: any) {
    if (data) {
      const currentTime = new Date();
      data.startDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      data.UpdatedBy = localStorage.getItem('username');

      // Handle project-related fields
      if (data.projectBOMCode) {
        data.projectBOMCode = data.projectBOMCode.split(' - ')[0];
      } else {
        data.projectBOMCode = null;
      }

      data.ProjectBoMName = data.fgProductCode?.split(' - ')[0] || '';
      data.ProjectBomDescription = '';

      // Ensure projectBoMId is null if not set
      if (!data.projectBoMId || data.projectBoMId === 0) {
        data.projectBoMId = null;
      }

      this.purchaseorderService.updateManufacturingOrders(data).subscribe({
        next: responseData => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Manufacturing Batch Updated Successfully.' });
        },
        error: error => {
          console.error('Error updating Manufacturing Batch:', error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while updating Manufacturing Batch.' });
        }
      });
    }
  }

  filterUOM(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.UOMDropdown as any[]).length; i++) {
      let uom = (this.UOMDropdown as any[])[i];
      if (uom.unitsofMeasureCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(uom);
      }
    }
    this.filteruom = filtered;
  }

  filteWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let warehouse = (this.warehouseDropdown as any[])[i];
      if (warehouse.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(warehouse);
      }
    }
    this.filtewarehouse = filtered;
  }

  validateForm(): boolean {
    let isValid = true;
    this.manufacturingOrdersForm.markAllAsTouched();
    const hasRequiredError = Object.keys(this.manufacturingOrdersForm.controls).some(controlName => {
      const control = this.manufacturingOrdersForm.get(controlName);
      return control?.hasError('required');
    });

    if (hasRequiredError) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please fill all required.',
      });
      isValid = false;
    }

    return isValid;
  }

  update(data: any) {
    this.submitted = true;

    this.manufacturingOrdersForm.get('endDate')?.clearValidators();
    this.manufacturingOrdersForm.get('quantity')?.clearValidators();
    this.manufacturingOrdersForm.get('endDate')?.updateValueAndValidity();
    this.manufacturingOrdersForm.get('quantity')?.updateValueAndValidity();

    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (data.quantity > 0 || data.endDate) {
      this.messageService.add({
        severity: 'error',
        detail: 'Updating Finish Date and Finish Qty is restricted for this operation.'
      });

      if (data.quantity > 0) {
        this.manufacturingOrdersForm.controls.quantity.reset(0);
      }

      if (data.endDate) {
        this.manufacturingOrdersForm.controls.endDate.reset();
      }

      return;
    }

    if (data) {
      const currentTime = new Date();

      data.startDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      data.UpdatedBy = localStorage.getItem('username');

      // project fields, same clean-up as finish()
      data.projectBOMCode = data.projectBOMCode ? data.projectBOMCode.split(' - ')[0] : null;
      data.ProjectBoMName = data.fgProductCode?.split(' - ')[0] || '';
      if (!data.projectBoMId || data.projectBoMId === 0) {
        data.projectBoMId = null;
      }

      this.loader = true;

      this.purchaseorderService.updatePBOMLineItem(this.NewLineItemData).subscribe({
        next: () => { },
        error: (error) => {
          console.error('PBOM update failed:', error);
          this.loader = false;
        }
      });

      this.purchaseorderService.updateProjectManufacturingOrders(data).subscribe({
        next: () => {
          this.storeconsumptionLineItemData.forEach(item => {
            item.ProjectManufacturingBatchID = this.projectManufacturingBatchID;
          });

          this.updateStoreConumption(this.storeconsumptionLineItemData);

          const hasInvalidItem = this.SaveDataLineItem.some(item => item.storeConsumptionlineItemId === 0);

          if (!hasInvalidItem) {
            const now = new Date();
            this.SaveDataLineItem.forEach(item => {
              if (item.date instanceof Date) {
                item.date.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
              }
            });
            this.purchaseorderService.updateStoreConsumptionLineItem(this.SaveDataLineItem).subscribe({
              next: (response) => console.log('Update successful:', response),
              error: (error) => console.error('Update failed:', error)
            });
          }

          this.loader = false;

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Manufacturing Batch Updated Successfully.'
          });

          this.purchaseorderService.deleteStoreConsumption(this.deleteProductIds).subscribe({
            next: () => { },
            error: (error) => {
              console.error('Error deleting store consumption:', error);
              this.loader = false;
            }
          });

          setTimeout(() => {
            this.route.navigate(['/home/listManufacturingOrders']);
          }, 1000);
        },
        error: (error) => {
          console.error('Error updating Project Manufacturing Batch:', error);
          this.loader = false;
        }
      });
    }
  }


  patchManufacturingOrders() {
    this.router.queryParams.subscribe(params => {
      this.projectManufacturingBatchID = params['projectManufacturingBatchID'];
      this.isEditMode = this.projectManufacturingBatchID;
      if (this.isEditMode) {
        this.purchaseorderService.getProjectManufacturingOrdersById(this.projectManufacturingBatchID).subscribe(
          (data: any) => {
            document.title = 'Update Manufacturing Order';
            this.QOHFromInventry = data;
            const startDate = data.startDate ? new Date(data.startDate) : null;
            const endDate = data.endDate ? new Date(data.endDate) : null;
            if (data) {
              this.data = data;
              this.manufacturingOrdersForm.patchValue({
                projectManufacturingBatchID: data.projectManufacturingBatchID,
                projectBoMId: data.projectBoMId,
                manufacturingBOMID: data.manufacturingBOMID,
                projectName: data.projectName,
                batchNumber: data.batchNumber,
                fgQuantity: data.fgQuantity,
                quantity: data.quantity,
                fgProductCode: data.fgProductCode,
                unitsOfMeasureCode: data.unitsOfMeasureCode,
                unitsOfMeasureId: data.unitsOfMeasureId,
                warehouseCode: data.warehouseCode,
                warehouseId: data.warehouseId,
                projectBOMCode: data.projectBOMCode,
                boMType: data.boMType,
                lotNumber: data.lotNumber,
                quantityOnHand: data.quantityOnHand,
                // wasteQuantity: data.wasteQuantity,
                productId: data.productId,
                Comment: data.comment,
                status: data.status,
                startDate: startDate,
                endDate: endDate,
                IsActive: data.isActive,
                CreatedBy: data.createdBy
              });

              // Unit cannot change after the job is saved
              this.manufacturingOrdersForm.controls.warehouseCode.disable();

              this.projectManufacturingBatchID = data.projectManufacturingBatchID;
              this.warehouseCode = data.warehouseCode;
              this.batchQuantity = data.fgQuantity;
              this.productIds = data.productId;
              this.projectBoMId = data.projectBoMId;
              this.warehouseId = data.warehouseId;
              this.getLineItemMO(data.projectManufacturingBatchID);
              this.getStoreConsumption(data.projectManufacturingBatchID);
              this.status = data.status;
            }
          },
          (error: any) => {
            console.error('Error fetching Project Manufacturing Batch data:', error);
          }
        );
      }
    });
  }

  cancel() {
    this.route.navigate(['/home/listManufacturingOrders']);
  }

  reset() {
    this.manufacturingOrdersForm.reset();
  }
  refreshForm() {
    this.manufacturingOrdersForm.reset();
    this.lineItemData = [];
  }

  get formControls() {

    return this.manufacturingOrdersForm.controls;
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }


  checkMONumber() {
    if (!this.manufacturingOrdersForm.controls.batchNumber.value) {
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEdit) {
      this.purchaseorderService.checkMONumber(this.manufacturingOrdersForm.controls.batchNumber.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.manufacturingOrdersForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  manualEntry() {
    const manualEntryValue = this.manufacturingOrdersForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.manufacturingOrdersForm.controls.batchNumber.setValue('');
    } else {
      this.getManufacturingBatch();
    }

  }

  getManufacturingBatch() {
    this.loader = true;
    this.purchaseorderService.autogenerateManufacturingBatchNumber().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'MO';
        // const order = alphanumericCode + data;
        //this.manufacturingOrdersForm.controls.batchNumber.setValue(_.toString(order));
        this.manufacturingOrdersForm.controls.batchNumber.setValue(data.fullNumber);
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }

  autosearchFinishGood(event: any) {
    setTimeout(() => {
      this.inventoryService.searchBillOfMaterials(event.query).subscribe(
        (data: any) => {
          if (data && data.bom) {
            this.filterFinishGoodList = data.bom;
          } else if (data && Array.isArray(data)) {
            this.filterFinishGoodList = data;
          } else {
            this.filterFinishGoodList = [];
          }

          this.NewLineItemData = [];
          this.manufacturingOrdersForm.controls.fgQuantity.reset();
          this.manufacturingOrdersForm.controls.unitsOfMeasureId.reset();
          this.manufacturingOrdersForm.controls.unitsOfMeasureCode.reset();
          this.manufacturingOrdersForm.controls.warehouse.reset();
          this.manufacturingOrdersForm.controls.warehouseId.reset();
          this.manufacturingOrdersForm.controls.quantityOnHand.reset();

        },
        (error: any) => {
          console.error('Error fetching BOM products:', error);
        }
      );
    }, 500);
  }


  setProduct(data: any) {
    const bomData = data.value;

    const uomCode = bomData.unitsOfMeasureCode;
    const uomId =
      bomData.unitsOfMeasureId ??
      (this.UOMDropdown.find(u => u.unitsofMeasureCode === uomCode) as any)?.unitsofMeasureId ??
      null;

    this.manufacturingOrdersForm.controls.fgProductCode.setValue(bomData.productCode);
    this.manufacturingOrdersForm.controls.productId.setValue(bomData.productId);
    this.manufacturingOrdersForm.controls.unitsOfMeasureId.setValue(uomId);
    this.manufacturingOrdersForm.controls.unitsOfMeasureCode.setValue(uomCode);
    this.manufacturingOrdersForm.controls.warehouseId.setValue(bomData.warehouseId);
    this.manufacturingOrdersForm.controls.warehouseCode.setValue(bomData.warehouseCode);
    this.manufacturingOrdersForm.controls.quantityOnHand.setValue(bomData.quantityOnHand);
    this.manufacturingOrdersForm.controls.fgQuantity.setValue(bomData.quantityAvailable);
    this.manufacturingOrdersForm.controls.boMType.setValue(bomData.boMType);
    this.manufacturingOrdersForm.controls.fgQuantity.setValue(bomData.quantity);

    this.getBillOfMaterialLineItem(bomData.bomId);

    this.data = data;
    this.warehouseId = bomData.warehouseId;
    this.productCode = bomData.productCode;
    this.QOHFromInventry = bomData;
  }

  setWarehouse(data: any) {
    if (data.value) {
      this.manufacturingOrdersForm.controls.warehouseId.setValue(data.value.warehouseId);
      this.manufacturingOrdersForm.controls.warehouseCode.setValue(_.toString(data.value.warehouseName));
      const productCode = this.manufacturingOrdersForm.value.fgProductCode?.split(' - ')[0];
      if (productCode) {
        // this.getInventoryStatus(productCode);
      } else {
        console.warn('Product code is not available.');
      }
    }
  }


  get formControlsmo() {
    return this.manufacturingOrdersForm.controls;
  }

  onUnitOfMeasureSelect(event: any) {
    if (this) {
      this.manufacturingOrdersForm.controls.unitsOfMeasureCode.setValue(_.toString(event.value.unitsofMeasure));
      this.manufacturingOrdersForm.controls.unitsOfMeasureId.setValue(event.value.unitsofMeasureId);
    }
  }

  getUOM() {
    this.administratorService.getAllUnitsOfMeasure(this.pageRequest).subscribe({
      next: (data: any) => {
        this.UOMDropdown = data.unitsofMeasures;
      },
      error: error => {
      }
    });
  }

  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
        // console.log(data);
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getVendors() {
    this.vendorService.getAllVendor(this.pageRequest).subscribe({
      next: (data: any) => {
        this.vendorDropdown = data.vendors;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterVendor(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.vendorDropdown as any[]).length; i++) {
      let vendor = (this.vendorDropdown as any[])[i];
      if (vendor.vendorName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filterVendorList = filtered;
  }

  onVendorSelect(event: any, bomLineitem: any) {
    if (event.value) {
      bomLineitem.vendorId = event.value.vendorId;
      bomLineitem.vendorCode = event.value.vendorCode;
      bomLineitem.vendorName = event.value.vendorName;
    }
  }


  getInventoryStatusByWarehouse(): void {
    this.inventoryService.getInventoryStatusByWarehouse(this.warehouseId).subscribe({
      next: (inventoryData: any) => {
        inventoryData.forEach((inventoryItem: any) => {
          const product = this.NewLineItemData.find(p => p.productId === inventoryItem.productId);
          if (product) {
            product.quantityAvailable = inventoryItem.quantityAvailable;
            product.quantityInProcess = inventoryItem.quantityInProcess;
          }
        });

        this.NewLineItemData.forEach(item => {
          item.productCost = this.getProductCost(item);
          item.extendedCost = this.getExtendedCost(item);
        });
      },
      error: error => {
        console.log(error);
      }
    });
  }


  newStoreConsumption(ProjectManufacturingBatchID: any, mode: 'new' | 'edit' = 'new') {
    let selectedItem = null;

    if (mode === 'edit' && ProjectManufacturingBatchID) {
      selectedItem = ProjectManufacturingBatchID;
    } else if (this.selectedProduct && this.selectedProduct.length === 1) {
      selectedItem = this.selectedProduct[0];
    }

    this.refStoreConsumption = this.dialogService.open(StoreConsumptionLookupComponent, {
      width: '80%',
      header: mode === 'new' ? 'Add Store Consumption' : 'Edit Store Consumption',
      data: {
        ProjectManufacturingBatchID: selectedItem?.ProjectManufacturingBatchID || ProjectManufacturingBatchID,
        warehouseId: this.warehouseId,
        storeconsumptionLineItemData: mode === 'edit' ? selectedItem : null,
        SaveDataLineitem: this.SaveDataLineItem,
        mode: mode
      },
      styleClass: 'no-close-icon-dialog'
    });

    this.refStoreConsumption.onClose.subscribe((data: any) => {
      this.selectedProduct = [];
      if (data) {
        this.SaveData = data.saveData;
        this.SaveDataLineItem = data.SaveDataLineitem;
        const saveItem = data.saveData;

        if (saveItem) {
          const exists = this.storeconsumptionLineItemData.some(item => item.scCode === saveItem.scCode);
          if (exists) {
            this.storeconsumptionLineItemData = this.storeconsumptionLineItemData.map(item =>
              item.scCode === saveItem.scCode ? { ...item, ...saveItem } : item
            );
          } else {
            this.storeconsumptionLineItemData = [...this.storeconsumptionLineItemData, saveItem];
          }
        }
      }
    });
  }

  updateStoreConumption(data: any) {
    if (data) {
      data.UpdatedBy = localStorage.getItem('username');
      this.loader = true;

      this.purchaseorderService.updateStoreCnsumption(data).subscribe({
        next: (data) => {

          this.loader = false;
        },
        error: (error) => {
          this.loader = false;
        },
      });


      this.ref.close();
    }
  }

  updateStoreConsumptionLineItem(data: any) {
    if (data) {
      setCurrentTimeOnDates([data]);
      this.purchaseorderService.updateStoreConsumptionLineItem(data).subscribe({
        next: (response: any) => {
          // Handle success if needed
        },
        error: error => {
          console.error('Error saving store consumption line items:', error);
        }
      });
    }
  }

  deleteStoreConsumption() {
    if (!this.selectedProduct || this.selectedProduct.length === 0) {
      return;
    }

    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;
        let selectedProductIds;

        selectedProductIds = this.selectedProduct.map(product => product.storeConsumptionId);

        this.removeLineItems(selectedProductIds);
        this.selectedProduct = [];

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Store Consumption Deleted successfully.' });
        this.loader = false;
      },
      reject: () => {
      }
    });
  }


  removeLineItems(selectedProductIds: any) {
    for (let id of selectedProductIds) {
      this.deleteProductIds = selectedProductIds;
      const index = this.storeconsumptionLineItemData.findIndex(item => item.storeConsumptionId === id);
      if (index !== -1) {
        this.storeconsumptionLineItemData.splice(index, 1);
      }
    }
  }



  createStoreConsumption(data: any) {
    data.IsActive = true;
    const currentTime = new Date();
    data.fromDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
    data.endDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());

    this.purchaseorderService.CreateStoreConsumption(data).subscribe({
      next: (response: any) => {
        this.storeconsumptionLineItemData = response;

        const existingStoreConsumptionId = response.id;
        const newItems = this.SaveDataLineItem.filter(item => item.storeConsumptionId === null);
        newItems.forEach(item => {
          item.storeConsumptionId = existingStoreConsumptionId;
        });

        // if (newItems.length > 0) {
        //    this.createStoreConsumptionLineItem(newItems);
        // }

      },
      error: error => {
        console.error('Error saving store consumption:', error);
      }
    });
  }

  getStoreConsumption(projectManufacturingBatchID: any) {
    this.loader = true;
    this.purchaseorderService.getStoreConsumptionByPmoId(projectManufacturingBatchID).subscribe(
      (data: any) => {
        this.storeconsumptionLineItemData = data;
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  private getCurrentUser(): string {
    return this.manufacturingOrdersForm.controls.CreatedBy.value
      || localStorage.getItem('username')
      || 'System';
  }

  async finish(data: any) {
    this.submitted = true;
    this.finishClicked = true;

    this.manufacturingOrdersForm.get('endDate')?.setValidators([Validators.required]);
    this.manufacturingOrdersForm.get('quantity')?.setValidators([Validators.required, Validators.min(1)]);
    this.manufacturingOrdersForm.get('endDate')?.updateValueAndValidity();
    this.manufacturingOrdersForm.get('quantity')?.updateValueAndValidity();

    if (!this.validateForm()) {
      return;
    }

    if (!data.endDate) {
      this.messageService.add({ severity: 'warn', detail: 'Finish Date Required.' });
      return;
    }

    if (!data.quantity || Number(data.quantity) <= 0) {
      this.messageService.add({ severity: 'warn', detail: 'Finish Quantity Required.' });
      return;
    }

    // if (data.wasteQuantity < 0) {
    //   this.messageService.add({
    //     severity: 'warn',
    //     detail: 'Finish quantity should be equal to or less than batch quantity.'
    //   });
    //   return;
    // }

    const now = new Date();
    data.endDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
    if (data.startDate && data.endDate <= data.startDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Date Range',
        detail: 'The finish date cannot be before or the same as the start date.'
      });
      return;
    }

    // Project-related fields
    data.projectBOMCode = data.projectBOMCode ? data.projectBOMCode.split(' - ')[0] : null;
    data.ProjectBoMName = data.fgProductCode?.split(' - ')[0] || '';
    data.ProjectBomDescription = '';
    if (!data.projectBoMId || data.projectBoMId === 0) {
      data.projectBoMId = null;
    }

    const user = this.getCurrentUser();
    data.UpdatedBy = user;
    data.CreatedBy = data.CreatedBy || user;

    // make sure the ID is sent so the backend updates the right row
    data.projectManufacturingBatchID = this.projectManufacturingBatchID;

    try {
      this.loader = true;

      // 1. save final (scaled) quantities + vendor / WIP date on the job lines
      if (this.NewLineItemData?.length > 0) {
        const finalLines = this.NewLineItemData.map(i => {
          const finalQty = this.getRequiredQty(i);         
          const cost = this.getProductCost(i);
          return {
            ...i,
            compQuantity: finalQty,
            totQty: finalQty,
            productCost: cost,
            extendedCost: +(finalQty * cost).toFixed(2)
          };
        });
        await firstValueFrom(this.purchaseorderService.updatePBOMLineItem(finalLines));
      }

      // 2. inventory for finish goods
      if (this.lineItemData?.length > 0) {
        for (const item of this.lineItemData) {
          const update: UpdateInventory = {
            productId: item.productId,
            warehouseId: item.warehouseId,
            productCode: item.productCode.split(' ')[0],
            quantity: data.quantity,
            status: 'FINISHMO',
            unitCost: 0,
            transactionNo: data.batchNumber,
            transactionType: 'BOM',
            createdBy: user,
            transactionDate: new Date(),
            createdDate: new Date(),
          };
          await this.inventoryService.updateInventory(update).toPromise();
        }
      }

      // 3. inventory for raw materials
      if (this.NewLineItemData?.length > 0) {
        for (const item of this.NewLineItemData) {
          const update: UpdateInventory = {
            productId: item.productId,
            warehouseId: data.warehouseId,
            quantity: this.getTotalQty(item),
            productCode: item.productCode.split(' ')[0],
            createdBy: user,
            status: 'FINISHMOLINEITEM',
            unitCost: 0,
            transactionNo: data.batchNumber,
            transactionType: 'Bill Of Material',
            transactionDate: new Date(),
            createdDate: new Date(),
          };
          await firstValueFrom(this.inventoryService.updateInventory(update));
        }
      }

      // 4. only after inventory succeeded, mark the batch as finished
      data.status = 'Batch Finished';
      await this.purchaseorderService.updateProjectManufacturingOrders(data).toPromise();

      this.manufacturingOrdersForm.controls.status.setValue('Batch Finished');
      this.status = 'Batch Finished';   // disables the buttons in the template

      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Manufacturing Batch finished successfully.' });

      setTimeout(() => {
        this.route.navigate(['/home/listManufacturingOrders']);
      }, 1000);

    } catch (error) {
      console.error('Error during finish process:', error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while finishing the manufacturing batch.' });
    } finally {
      this.loader = false;
    }
  }

  async updatePOInventory(ProductData: any) {
    try {
      const user = this.getCurrentUser();

      const Inventory = ProductData.map((item: { productId: any; warehouseId: any; productCode: any; totQty: any }) => ({
        productId: item.productId,
        warehouseId: item.warehouseId,
        productCode: item.productCode.split(' ')[0],
        status: 'CREATEMOFINISHMOLINEITEM',
        transactionType: '',
        transactionNo: '',
        quantity: item.totQty,
        createdBy: user,
        transactionDate: new Date(),
        createdDate: new Date(),
      }));

      this.loader = true;
      for (const update of Inventory) {
        await this.inventoryService.updateInventory(update).toPromise();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loader = false;
    }
  }


  navigateToCreateChallan() {
    this.route.navigate(['/home/create-challan'], {
      queryParams: {
        projectManufacturingBatchID: this.projectManufacturingBatchID,
        productIds: this.productIds,
        batchQuantity: this.batchQuantity,
        warehouseId: this.warehouseId,
        warehouseCode: this.warehouseCode
      },
      skipLocationChange: true,
    });
  }

  loadChallan(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getChallan();
  }

  getChallan(Status: string = 'All') {
    this.loader = true;
    this.inventoryService.getDeliveryChallan(this.pageRequest, Status).subscribe({
      next: (data: any) => {

        this.challanList = data.deliveryChallan.filter((challan: any) => challan.projectManufacturingBatchID === this.projectManufacturingBatchID
        );

        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }



  editChallan(data?: any) {
    if (data) {
      this.route.navigate(['/home/create-challan'], { queryParams: { 'deliveryChallanId': data.deliveryChallanId }, skipLocationChange: false },);
    } else {
      this.route.navigate(['/home/create-challan'], { queryParams: { 'deliveryChallanId': this.selectedChallan[0].deliveryChallanId }, skipLocationChange: false },);
    }
  }


  onSelectHandler(event: any) {
    this.setProduct(event);
  }

  onCompleteMethod(event: any) {
    this.autosearchFinishGood(event);
  }



  onProductEdit(bomLineitem: any): void {
    if (bomLineitem.wipDate) {
      let wipDateObj = new Date(bomLineitem.wipDate);

      if (isNaN(wipDateObj.getTime())) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Date',
          detail: 'Please enter a valid WIP Date.'
        });
        return;
      }
      const currentTime = new Date();
      wipDateObj.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      bomLineitem.wipDate = wipDateObj;
    }
  }

  getPOQuantity(compQuantity: number, quantityAvailable: number): number {
    const qty = Number(compQuantity) || 0;
    const avail = Number(quantityAvailable) || 0;
    return Math.max(qty - avail, 0);
  }


  // ---------------- AUTO PO ----------------

  async autoPO() {
    if (!this.isEditMode || this.status === 'Batch Finished') return;

    const rows = (this.NewLineItemData || [])
      .map(item => ({
        item,
        reqQty: this.getReqQty(item)
      }))
      .filter(x => x.reqQty > 0 && !x.item.poNumber);

    if (rows.length === 0) {
      this.messageService.add({
        severity: 'info',
        summary: 'Auto PO',
        detail: 'No pending shortage. All required materials already have a PO.'
      });
      return;
    }

    const noVendor = rows.filter(x => !x.item.vendorId);
    if (noVendor.length > 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Vendor required',
        detail: 'Select a vendor for: ' + noVendor.map(x => x.item.productCode?.split(' ')[0]).join(', ')
      });
      this.submitted = true;
      return;
    }

    const groups = new Map<number, { vendorId: number; vendorCode: string; vendorName: string; lines: any[] }>();
    for (const r of rows) {
      const id = r.item.vendorId;
      if (!groups.has(id)) {
        groups.set(id, { vendorId: id, vendorCode: r.item.vendorCode, vendorName: r.item.vendorName, lines: [] });
      }
      groups.get(id)!.lines.push(r);
    }
    const groupList = Array.from(groups.values());

    this.confirmationService.confirm({
      header: 'Create Purchase Orders',
      message: `${groupList.length} PO(s) will be created for ${rows.length} product(s):<br>` +
        groupList.map(g => `${g.vendorName} (${g.lines.length} item${g.lines.length > 1 ? 's' : ''})`).join('<br>'),
      accept: () => this.processAutoPO(groupList),
      reject: () => { }
    });
  }

  private async processAutoPO(groups: any[]) {
    const created: string[] = [];
    try {
      this.loader = true;

      await firstValueFrom(this.purchaseorderService.updatePBOMLineItem(this.NewLineItemData));

      const warehouseData: any = await firstValueFrom(this.administratorService.getWarehouseById(this.warehouseId));
      const warehouseState = warehouseData?.address?.state?.trim().toLowerCase();
      const unitSerial = warehouseData?.unitSerial;
      if (!unitSerial) throw new Error('Unit Serial is missing for this unit. Cannot generate PO number.');

      const deptData: any = await firstValueFrom(this.purchaseorderService.getDepartment(this.pageRequest));
      const departmentId = deptData?.department?.[0]?.departmentId;
      if (!departmentId) throw new Error('Department not found.');

      const user = this.getCurrentUser();
      const form = this.manufacturingOrdersForm.value;
      const today = new Date();

      for (const group of groups) {
        const vendor: any = await firstValueFrom(this.vendorService.getVendorById(group.vendorId));
        const vendorState = vendor?.address?.state?.trim().toLowerCase();
        const isIGST = !!warehouseState && warehouseState !== vendorState;

        const seq: any = await firstValueFrom(this.purchaseorderService.getAutogeneratedPoNumber(unitSerial));
        const poNumber = `${unitSerial}${seq}`;

        const lines: any[] = [];
        let taxable = 0, cgstTotal = 0, sgstTotal = 0, igstTotal = 0, qtyTotal = 0;
        let lineNo = 0;

        for (const { item, reqQty } of group.lines) {
          lineNo++;
          const product: any = await firstValueFrom(this.inventoryService.getProductById(item.productId));

          const cost = this.getProductCost(item);
          const extended = +(reqQty * cost).toFixed(2);
          const gstRate = Number(product?.gst?.gstRate ?? product?.gstRate ?? 0);
          const tax = product?.isTaxable ? +(extended * gstRate / 100).toFixed(2) : 0;
          const cgst = isIGST ? 0 : +(tax / 2).toFixed(2);
          const sgst = isIGST ? 0 : +(tax / 2).toFixed(2);
          const igst = isIGST ? tax : 0;

          lines.push({
            PurchaseOrderNumber: poNumber,
            ProductId: item.productId,
            ProductCode: product?.productCode ?? item.productCode?.split(' ')[0],
            ProductDescription: product?.productName ?? '',
            ProductSpecification: product?.productSpecification ?? '',
            POQuantity: reqQty,
            ReceivedQuantity: 0,
            LineItemNumber: lineNo,
            Uom: item.unitsOfMeasureCode ?? product?.purchasingUom,
            IsTaxable: product?.isTaxable,
            HSNCode: product?.hsnCode,
            Cost: cost,
            Discount: 0,
            ExtendedCost: extended,
            NetAmount: extended,
            GSTRate: gstRate,
            CGST: cgst,
            SGST: sgst,
            IGST: igst,
            LineTotal: +(extended + tax).toFixed(2),
            Weight: 0,
            Comment: '',
            DateRequired: today,
            projectBoMId: form.projectBoMId ?? null,
            IsActive: true,
            CreatedBy: user
          });

          taxable += extended;
          cgstTotal += cgst;
          sgstTotal += sgst;
          igstTotal += igst;
          qtyTotal += reqQty;
        }

        const taxTotal = cgstTotal + sgstTotal + igstTotal;

        const po = {
          purchaseOrderNumber: poNumber,
          AddressId: 0,
          WarehouseId: this.warehouseId,
          warehouseCode: warehouseData?.warehouseCode,
          unitSerial: unitSerial,
          createdDate: today,
          requestedDate: today,
          vendorId: group.vendorId,
          vendorCode: group.vendorCode,
          vendorName: group.vendorName,
          paymentTermsId: vendor?.paymentTerms?.paymentTermsId ?? vendor?.paymentTermsId ?? null,
          termsCode: vendor?.paymentTerms?.termsCode ?? vendor?.termsCode ?? '',
          DepartmentId: departmentId,
          POTotal: +(taxable + taxTotal).toFixed(2),
          FinalTaxableAmt: +taxable.toFixed(2),
          TaxTotal: +taxTotal.toFixed(2),
          CGSTTotal: +cgstTotal.toFixed(2),
          SGSTTotal: +sgstTotal.toFixed(2),
          IGSTTotal: +igstTotal.toFixed(2),
          TotalWeight: qtyTotal,
          FreightAmount: 0,
          PackingForwarding: 0,
          DiscountAmount: 0,
          PurchaseOrder_Status: this.autoPOStatus,
          IsActive: true,
          CreatedBy: user,
          projectBoMId: form.projectBoMId ?? null,
          projectName: form.projectName ?? null,
          ProjectNo: form.projectBOMCode ? form.projectBOMCode.split(' - ')[0] : null,
          purchaseOrderComment: `Auto PO from Manufacturing Job ${form.batchNumber}`
        };

        await firstValueFrom(this.purchaseorderService.createPurchaseOrder(po));

        for (const line of lines) {
          await firstValueFrom(this.purchaseorderService.createPurchaseOrderLineItem(line));
          await this.updateCreatePOInventory(line, user);
        }

        group.lines.forEach((l: any) => (l.item.poNumber = poNumber));
        await firstValueFrom(this.purchaseorderService.updatePBOMLineItem(this.NewLineItemData));

        created.push(poNumber);
      }

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `${created.length} Purchase Order(s) created: ${created.join(', ')}`
      });

      this.getInventoryStatusByWarehouse();
    } catch (error: any) {
      console.error('Auto PO failed:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Auto PO failed',
        detail: (error?.message ? error.message + ' ' : '') +
          (created.length ? `Created before the failure: ${created.join(', ')}.` : '')
      });
    } finally {
      this.loader = false;
    }
  }

  onReqQtyChange(item: any, value: any) {
    if (value === null || value === '' || value === undefined) {
      item.reqQty = null;
      return;
    }
    const n = Number(value);
    item.reqQty = isNaN(n) || n < 0 ? 0 : n;
  }

  get hasPendingPO(): boolean {
    return (this.NewLineItemData || []).some(i => !i.poNumber && this.getReqQty(i) > 0);
  }

  private async updateCreatePOInventory(line: any, user: string) {
    const inventory: any = {
      productId: line.ProductId,
      warehouseId: Number(this.warehouseId),
      productCode: line.ProductCode,
      status: 'CreatePO',
      transactionType: '',
      transactionNo: line.PurchaseOrderNumber,
      quantity: line.POQuantity,
      uom: line.Uom,
      createdBy: user,
      transactionDate: new Date(),
      createdDate: new Date()
    };
    await firstValueFrom(this.inventoryService.updateInventory(inventory));
  }


  private getScaleRatio(): number {
    if (this.status === 'Batch Finished') return 1;   
    const produce = Number(this.manufacturingOrdersForm.controls.fgQuantity.value) || 0;
    const finish = Number(this.manufacturingOrdersForm.controls.quantity.value) || 0;
    return (finish > 0 && produce > 0) ? finish / produce : 1;
  }

  getRequiredQty(item: any): number {
    const base = Number(item?.compQuantity) || 0;
    return +(base * this.getScaleRatio()).toFixed(3);
  }

  getTotalQty(item: any): number {
    const base = (Number(item?.compQuantity) || 0) + (Number(item?.wastage) || 0);
    return +(base * this.getScaleRatio()).toFixed(3);
  }

  getExtendedCost(item: any): number {
    return +(this.getRequiredQty(item) * this.getProductCost(item)).toFixed(2);
  }

  getReqQty(item: any): number {
    if (item?.reqQty !== undefined && item?.reqQty !== null) {
      return Number(item.reqQty) || 0;
    }
    return this.getPOQuantity(this.getRequiredQty(item), item.quantityAvailable || 0);
  }

}
